export default {
  i: {
    select: {
      placeholder: '請選擇',
      noMatch: '無匹配數據',
      loading: '加載中'
    },
    table: {
      noDataText: '暫無數據',
      noFilteredDataText: '暫無篩選結果',
      confirmFilter: '篩選',
      resetFilter: '重置',
      clearFilter: '全部'
    },
    datepicker: {
      selectDate: '選擇日期',
      selectTime: '選擇時間',
      startTime: '開始時間',
      endTime: '結束時間',
      clear: '清空',
      ok: '確定',
      month: '月',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      year: '年',
      weeks: {
        sun: '日',
        mon: '壹',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        m1: '1月',
        m2: '2月',
        m3: '3月',
        m4: '4月',
        m5: '5月',
        m6: '6月',
        m7: '7月',
        m8: '8月',
        m9: '9月',
        m10: '10月',
        m11: '11月',
        m12: '12月'
      }
    },
    transfer: {
      titles: {
        source: '源列表',
        target: '目的列表'
      },
      filterPlaceholder: '請輸入搜索內容',
      notFoundText: '列表為空'
    },
    modal: {
      okText: '確定',
      cancelText: '取消'
    },
    poptip: {
      okText: '確定',
      cancelText: '取消'
    },
    page: {
      prev: '上壹頁',
      next: '下壹頁',
      total: '共',
      item: '條',
      items: '條',
      prev5: '向前 5 頁',
      next5: '向後 5 頁',
      page: '條/頁',
      goto: '跳至',
      p: '頁'
    },
    rate: {
      star: '星',
      stars: '星'
    },
    tree: {
      emptyText: '暫無數據'
    }
  },
  logisticsMenu: {
    logisCurrentPosition: '當前位置',
    logisticsProvider: '物流商',
    personalCenter: '個人中心',
    channelManagement: '渠道管理',
    logisticsDealer: '包裹管理',
    customerAnalysis: '客戶分析',
    customerManagement: '客戶管理',
    waybillNumber: '運單號管理',
    pricingModelManagement: '計費模型',
    logisManagement: '基础信息管理',
    logisBizManagement: '业务信息管理',
    logisAccessManagement: '访问管理',
    FreightForwarding: '貨代',
    OverseasWarehouse: '海外倉',
    warehouseManagement: '倉庫管理',
    findpassword: '找回密碼',
    dataReview: '物流审核',
    carrierParam: '物流信息',
    statisticsPackageInfo: '包裹统计被动对接)',
    carrierAccount: '物流賬號',
    accessStatistics: '访问管理',
    accessStatistics_admin: '接口频率统计(被动对接)',
    packageInfo: '包裹信息(被动对接)',
    logManagement: '日志管理(主动对接)'
  },
  logisticsProvider: {
    country: '國家',
    hasCountry: '已選中國家',
    wayname: '客戶',
    trackNum: '已用跟踪號',
    noTrackNum: '未用跟踪號',
    channelName: '渠道名稱',
    channelNum: '渠道代碼',
    shippingCompanyId: '物流公司ID',
    useAll: '總使用數',
    addtext: '文本添加',
    excelImport: 'excel導入',
    textPlaceholder: '請輸入跟踪號，多個用英文逗號隔開',
    trackExcelImport: '導入跟踪號',
    addTrack: '請選擇導入文件',
    addFile: '選擇文件',
    uploadFile: '上傳文件',
    downLoadMoban: '下載模板',
    baseInformation: '基本信息',
    remark: '此界面提供修改的數據以必填的爲準，非必填的未必有使用到，可爲後續擴展。非必填數據部分未填寫的會自動填寫默認值，請悉知。',
    channelInformation: '渠道信息',
    channelType: '類型',
    packageNum: '包裹數',
    cost: '費用',
    region: '地區',
    logisticsTrackNum: '物流跟踪號',
    packageNums: '包裹號',
    weight: '重量(g)',
    date: '日期',
    companyInfo: '公司信息',
    exceedSize: '文件大小超出限制，最大為10M',
    editData: '修改資料',
    overPackage1: '您已超過',
    overPackage2: '的物流商',
    addCanal: '新增',
    addChannels: '新增渠道',
    addWarehouse: '新增倉庫',
    expectTime: '預計時效',
    chargingModel: '計費模型',
    shipment: '物流商',
    shipImport: '導入',
    addZone: '新增分區',
    area: '區',
    setChargModel: '設置計費模型',
    province: '省份',
    city: '城市',
    searchCity: '查詢城市',
    noFile: '請選擇文件',
    loadExcelTitle: '導入運費模板',
    loadExcelShippingMethod: '導入渠道模板',
    downloadExcel: '模板下載',
    selectExcel: '選擇需要導入的模板',
    importSuccess: '導入數據成功',
    priceFormula: '計費公式',
    enterShipDes: '可以輸入發貨說明',
    editWaybillNum: '編輯運單號',
    addChannelInfo: '新增渠道信息',
    editChannelInfo: '編輯渠道信息',
    importCountryNoFind: '導入的部分通達國家沒在系統中找到',
    confirmAdd: '確認添加',
    selectAll: '全選',
    clear: '清空',
    addWeightArea: '新增重量區間',
    supportSearch: '支持中文、英文、二字碼搜索',
    selectedCity: '已選中城市',
    prompt: '提示',
    warehouseName: '倉庫名稱',
    warehouseCode: '倉庫代碼',
    warehouse: '倉庫',
    merchant: '商戶',
    merchantId: '商戶號',
    template: '模板',
    templateName: '模板名稱',
    customInformation: '定製模板信息'
  },
  admin: {
    ttPacketId: '包裹号',
    merchantId: '商户号',
    ttPacketStatus: '包裹状态',
    failureReason: '失败原因',
    trackingNumber: '跟踪号',
    shippingMethodCode: '渠道编码',
    warehouse: '仓库',
    platform: '销售平台',
    length: '长',
    width: '宽',
    height: '高',
    recipientName: '收件人姓名',
    recipientTelephone: '收件人电话',
    recipientMobile: '收件人手机',
    recipientEmail: '收件人邮箱',
    recipientCountry: '收件人国家',
    recipientState: '收件人省/州',
    recipientCity: '收件人城市',
    recipientDistrict: '收件人区/县',
    recipientCompany: '收件人公司',
    recipientPostalCode: '收件人邮编',
    buyerPassportCode: '收件人识别编号',
    isSecondaryForecast: '是否属于二次预报业务',
    secondaryForecastStatus: '二次预报状态',
    secondaryForecastLabelUrl: '二次预报面单地址',
    buyerDoorNo: '收件人门牌号',
    buyerShortAddress: '收件人短地址',
    buyerRegion: '收件人大区',
    recipientAddress1: '收件人地址1',
    recipientAddress2: '收件人地址2',
    senderName: '寄件人姓名',
    senderTelephone: '寄件人电话',
    senderMobile: '寄件人手机',
    senderEmail: '寄件人邮箱',
    senderCountry: '寄件人国家',
    senderState: '寄件人省/州',
    senderCity: '寄件人城市',
    senderDistrict: '寄件人区/县',
    senderCompany: '寄件人公司',
    senderPostalCode: '寄件人邮编',
    senderAddress1: '寄件人地址1',
    senderAddress2: '寄件人地址2',
    declareCnName: '申报中文品名',
    declareEnName: '申报英文品名',
    goodsSku: '申报产品SKU',
    declareNumber: '申报产品数量',
    declareValue: '货品申报价值',
    declareWeight: '货品申报重量',
    hsCode: '海关编码',
    declareUrl: '申报的产品链接',
    material: '产品材质',
    purpose: '产品用途',
    productName: '货品名称',
    sku: 'SKU',
    quantity: '货品数量',
    productWeight: '单品重量',
    cargoSpace: '货位号',
    iossMethod: '预缴增值税方式',
    iossNo: '卖家IOSS税号',
    eoriNo: '卖家EORI税号',
    voecNo: '卖家VOEC税号',
    gstNo: '卖家GST税号',
    vatNo: '卖家VAT税号',
    paidonCompleteTime: '订单付款完成时间',
    actualTotalPrice: '订单实付金额',
    companyName: '生产销售单位名称',
    creditCode: '生产销售单位证件号码',
    salesRecordNumber: '销售订单号',
    carrierOrderId: '物流单号',
    virtualTrackingNumber: '虚拟跟踪号',
    uploadCarrier: '承运商',
    weight: '重量',
    freight: '运费',
    templateType: '面单类型',
    templateContent: '面单地址',
    createdDate: '包裹生成时间',
    lastsyncTime: '最新同步时间',
    requestId: '请求ID',
    source: '来源',
    apiInterface: '物流商标识',
    method: '请求方式',
    interfaceFlag: '接口标识',
    carrierId: '物流商ID',
    rangeTime: '时间范围',
    packageStatus: '包裹状态',
    packageNum: '包裹数量'
  },
  sellerMenu: {
    sellerCurrentPosition: '當前位置',
    seller: '賣家',
    personalCenter: '個人中心',
    logisticsPlan: '物流方案查詢',
    logisticsTracking: '物流追踪',
    logisticsReconciliation: '物流對賬',
    logisBillManage: '物流賬單管理',
    logisticsProvider: '我的物流商分析',
    logisticsChannel: '我的物流渠道分析',
    logisticsDetails: '物流詳情',
    overseasWarehouse: '海外倉',
    overseasWarehouseDtl: '海外倉詳情',
    overseasWarehouseInvent: '海外倉庫存',
    overseasWarehouseBill: '海外倉賬單'
  },
  sellers: {
    overSeller1: '您已超過',
    overSeller2: '的賣家',
    countrys: '目的國家',
    packageWeights: '包裹重量',
    packageVolumes: '包裹體積',
    packageType: '包裹類型',
    productsType: '貨物類型',
    isEnabled: '是否啟用',
    receiveCity: '攬收城市',
    selectCity: '選擇攬收城市',
    userContactInfoTitle: '您的聯繫方式',
    shippingMethodName: '渠道名稱',
    carrierName: '物流商名稱',
    tongtoolExpoent: '通途推薦指數',
    averageTime: '平均時效',
    avgNetTime: '平均上網時間',
    availableTrackingRate: '有效追踪率(%)',
    lostPackageRate: '丢包率',
    pickupRate: '妥投率',
    selectCarrier: '選擇物流商',
    packageNums: '包裹號',
    trackingNumber: '物流單號',
    erpPackageWeight: '通途重量',
    packageWeight: '物流商重量',
    weightAddRatio: '重量增加比(%)',
    erpPackageCost: '通途費用',
    packageCost: '物流商費用',
    costs: '費用',
    costAddRatio: '費用增加比(%)',
    selectExcel: '選擇需要導入的模板',
    confirmImport: '確認導入',
    importLogisWeights: '導入物流商重量和費用',
    packageQuantity: '包裹數',
    useRatio: '使用佔比(%)',
    costRatio: '費用佔比(%)',
    shippingMethodCode: '渠道代碼',
    isValid: '狀態',
    shipDetails: '詳情',
    avgDelieveredTime: '平均妥投時間',
    shortDelieveredTime: '最短妥投時間',
    longDelieveredTime: '最長妥投時間',
    platform: '平台',
    storeName: '店鋪',
    country: '國家',
    shippingMethods: '物流方式',
    recentData: '統計最近90天數據',
    logisTrackInfo: '物流跟踪信息',
    targetLanguage: '請選擇要轉換的目標語言',
    copyResult: '複製結果',
    copyLink: '複製鏈接',
    languageConver: '語言轉換',
    packetStatus: '包裹狀態',
    transportMethods: '運輸方式',
    transportTime: '運輸時間',
    basicInfo: '基本信息',
    timeAndFreight: '時效及運費',
    templateManagement: '面單管理',
    tongToolTemplate: '通途模板',
    logisTemplate: '物流商模板',
    personalTemplate: '個人模板',
    arrivalTime: '預計妥投時間',
    unableShow: '該字段暫時無法顯示',
    contactLogisProvider: '聯繫物流商',
    channelDtlTitle: '渠道詳情',
    estimateFreight: '預估運費',
    querying: '查詢中',
    delivering: '運輸途中',
    pickingUp: '到達待取',
    signingSuccess: '成功簽收',
    unableCheck: '查詢不到',
    deliveryFail: '投遞失敗',
    transportLong: '運輸過久',
    maybeAbnormal: '可能異常',
    logisFreightModel: '物流商計費模型',
    customShipModel: '自定義計費模型',
    billGenerateTime: '賬單生成時間',
    importBill: '導入賬單',
    billTimes: '賬單時間',
    selectBillTime: '請選擇賬單生成時間',
    downloadDetails: '詳情下載',
    downloads: '下載',
    paymentStatus: '付款狀態',
    markAsPaid: '標記為已付款',
    selectLogisProvider: '請選擇物流商',
    selectBillingTime: '請選擇賬單時間',
    paid: '已付款',
    unPaid: '未付款',
    importFormFile: '導入表格文件'
  },
  common: { // 重复类名词 + 公共操作提示
    merchantId: '商戶編號',
    partnerId: '用戶編號',
    companyName: '公司名稱',
    displayCarrierName: '在通途顯示的物流商名稱',
    companyAds: '公司地址',
    email: '企業郵箱',
    mobile: '手機號碼',
    contactName: '聯繫人',
    businessLicense: '營業執照',
    supportPdf: '支持上傳PDF文件',
    telephone: '聯繫電話',
    packNum: '包裹數量（近30天包裹數量）',
    yesterdayPm: '昨天包裹量',
    packageAmount: '包裹量',
    dates: '日期',
    nocompanyImg: '暫無圖片',
    dataSources: '數據來源：通途物流平台',
    productServer: '產品服務',
    productName: '產品名稱',
    productDes: '產品介紹',
    orderPrice: '訂購價格',
    productStatus: '狀態',
    searchName: '搜索字符',
    markSuccess: '標記成功',
    markFailed: '標記失敗',
    editSuccess: '修改成功',
    saveSuccess: '保存成功',
    editFailed: '修改失敗',
    saveFailed: '保存失敗',
    delSuccess: '刪除成功',
    delFailed: '刪除失敗,請重新嘗試',
    clearMakrSuccess: '清空標籤成功',
    operateSuccess: '操作成功',
    operateFailMes: '操作失敗，請重新嘗試',
    sysErrorMes: '系統繁忙，請重新嘗試',
    lastWeek: '最近一周',
    lastMonth: '最近一個月',
    last3months: '最近三個月',
    selectDate: '選擇日期',
    deliveryDate: '發貨日期',
    search: '查詢',
    statisticsAllPackageInfo: '统计所有包裹信息',
    reset: '重置',
    status: '狀態',
    checkStatus: '審覈狀態',
    checkStatusFinish: '审核完成',
    operation: '操作',
    sort: '排序',
    close: '關閉',
    save: '保存',
    saveAndApproval: '保存並提交審覈',
    submit: '提交',
    cancel: '取消',
    edit: '編輯',
    cancelEdit: '取消編輯',
    all: '全部',
    examine: '查看',
    del: '刪除',
    logout: '登出',
    inputPrefix: '請輸入',
    selectPrefix: '請選擇',
    enableOk: '啟用成功',
    disableOk: '停用成功',
    delOk: '刪除成功',
    addOk: '新增成功',
    updateOk: '更新成功',
    deleteConfirm: '是否確認刪除?',
    confirm: '確定',
    notNull: '不能為空',
    processing: '處理中...',
    emptyResult: '沒有相關記錄',
    warningMesTitle: '警告提示',
    selectFile: '選擇文件',
    startUpload: '開始上傳',
    shipImport: '導入',
    shipExport: '導出',
    exportSuccess: '導出成功',
    tableNoData: '當前沒有可導出的數據',
    selectCountry: '選擇國家',
    selectShipMethods: '選擇物流方式',
    priceType: '計費方式',
    priceType0: '普通計費',
    priceType1: '首續重計費',
    priceType2: '分段計費',
    weightType: '計重方式',
    weightType0: '實重',
    weightType1: '抛重',
    weightType2: '兩者比較',
    subCostWay0: '單位重量',
    subCostWay1: '固定收費',
    subCostWay2: '首續重收費',
    tableDes0: '運費 = (重量 * 單價 + 掛號費 + 操作費) * (1 + 附加費)',
    tableDes1: '運費 = {首重費用 + (包裹重量 - 首重) / 續重單位重量 * 續重單價 + 掛號費 + 操作費} * (1 + 附加費)',
    tableDes2: '運費 = (單價 + 掛號費 + 操作費) * (1 + 附加費)',
    logisType1: '平郵',
    logisType2: '掛號',
    logisType3: '專線',
    logisType4: '商業快遞',
    logisType5: 'FBA頭程',
    serialNum: '序號',
    status0: '停用',
    status1: '啟用',
    companyAttr: '公司屬性',
    thirdLogis: '第三方物流',
    overseasWarehouse: '海外倉',
    checkBtn: '審覈',
    refuseBtn: '拒絕',
    rejected: '已拒絕',
    dataReviewStatus: '審覈狀態',
    dataReviewStatus0: '待申請',
    dataReviewStatus1: '待審覈',
    dataReviewStatus2: '審覈成功',
    dataReviewStatus3: '審覈失敗',
    searchText: '公司名稱/手機號碼/郵箱/物流商名稱',
    checkstatus0: '待審覈',
    checkstatus1: '已審覈',
    checkstatus2: '已拒绝',
    checkstatus: '審覈通過',
    checkstatusRj: '审核拒绝',
    cargo: '普貨',
    battery: '純電池',
    supBattery: '配套電池',
    liquid: '液體',
    medicine: '藥品',
    powder: '粉末',
    dangerous: '危險品',
    package: '包裹',
    file: '文件',
    yes: '是',
    not: '否',
    referTime: '參考時效',
    safeServe: '保險服務',
    sizeLimit: '尺寸限制',
    useWeight: '適用重量',
    packageType: '可接受包裹類型',
    acceptType: '接收類型',
    haveTrackNum: '是否有跟踪號',
    channelTypes: '渠道類型',
    isPrintTemplate: '是否支持API接口傳送面單',
    updateToErp: '是否推送到ERP2.0',
    confirmRequired: '是否需要交運',
    volumeWeight: '材積重',
    trackUrl: '追踪信息查詢網址',
    collectCity: '攬收城市',
    dyParams: '動態參數',
    dyParamsExtend: '动态参数扩展信息',
    sendExplain: '發貨說明',
    searchLogisName: '搜索物流商名稱',
    searchChannelName: '搜索渠道名稱',
    searchChannelCode: '搜索渠道代碼',
    warehosueName: '搜索倉庫名稱',
    submitSuccess: '提交成功，等待物流商聯繫您',
    pleaseEnter: '請檢查你填寫的值是否符合要求',
    importFileSuccess: '導入文件成功',
    importFileFail: '導入文件失敗',
    fileFormats: '文件格式',
    subArea: '分區',
    reachState: '通達國家',
    costPrice: '價格（元/g）',
    fixPrice: '價格（元/票）',
    registrationFee: '掛號費（元/票）',
    operatingCost: '操作費（元/票）',
    additionalFeeRate: '附加費（%）',
    firstWeight: '首重（g）',
    firstWeightPrice: '首重運費（元）',
    unitWeight: '續重單位重量（g）',
    unitWeightPrice: '續重單價（元）',
    monetaryUnit: '元',
    unitWeightTwo: '續重',
    firstWeightTwo: '首重',
    length: '長',
    width: '寬',
    height: '高',
    pleaseSelect: '請選擇',
    fileSizeLimit: '超過文件大小限制',
    moreSize: '太大，不能超過2M',
    findSameCountry: '模板導入發現相同國家時',
    cover: '覆蓋',
    ignore: '忽略',
    errorMessage: '錯誤提示',
    downloadErrorLog: '下載錯誤日誌',
    startWeights: '起始重量（g）',
    endWeights: '截止重量<=（g）',
    batchImport: '批量導入',
    newPartition: '新增分區',
    backToList: '返回列表',
    checkErrorLog: '計費模型導入內容有誤，請查看錯誤日誌',
    isCheckStatus: '是否需要審覈',
    label: '自制模板',
    userNo: '用戶編號',
    carrierCode: '物流商代碼',
    carrierType: '物流商类型',
    apiType: 'API类型编码',
    remark: '備註',
    appmanage: '應用管理',
    addparam: '新增參數',
    parameterName: '參數名',
    parameterKey: '參數key',
    parameterType: '参数类型',
    businessType: '参数业务类型',
    dataType: '数据类型',
    optionName: '可选项名',
    optionValue: '可选项值',
    addAccount: '添加賬戶',
    updateAccount: '更新账号',
    updatePassword: '更新密码',
    hasAccount: '是否有賬號',
    alreadyAccount: '已有賬號',
    noAccount: '未有賬號',
    accountName: '賬號名稱',
    password: '密碼',
    account: '賬號',
    carrierSystem: '物流系統',
    sync: '同步',
    initExtend: '初始化渠道扩展信息',
    bindType: '绑定类型',
    isSupportSmartRouting: '是否支持智能路由',
    isSupportPrivateChannelSync: '是否支持客户私有渠道同步',
    isSupportSecondaryForecast: '是否支持二次预报业务',
    secondaryForecastType: '二次预报类型',
    isEnableSynStock: '是否支持API同步库存',
    isSupportApiRecord: '是否支持API补录运费',
    accessTime: '访问时间',
    packageCreatedTime: '包裹创建时间',
    accessTimeRange: '访问时间范围',
    totalTimes: '访问频率',
    callMethod: '接口名称'
  },
  validValue: { // 所有的校验callback内容都写在这里，避免重复
    noEmpty: '內容不能為空',
    errorDate: '日期格式有誤',
    fileError: '文件格式有誤',
    inputError: '輸入格式有誤',
    floatNeed: '該選項只允許輸入整數或兩位小數',
    noshipMethodName: '渠道名稱不能為空',
    noMerchantId: '商戶不能爲空',
    noTemplateId: '模板不能爲空',
    nowarehosueName: '倉庫代碼不能爲空',
    noshipMethodCode: '渠道代碼不能為空',
    nowarehouseCode: '倉庫代碼不能爲空',
    noReceiveType: '請選擇接收類型',
    noLogisType: '請選擇渠道類型',
    noEfficiencyMin: '最小參考時效不能為空',
    noEfficiencyMax: '最大參考時效不能為空',
    noLength: '長度不能為空',
    noWidth: '寬度不能為空',
    noHeight: '高度不能為空',
    noWeightStart: '重量起始值不能為空',
    noWeightEnd: '重量截止值不能為空',
    chMethodCode: '渠道代碼不能為中文',
    isInteger: '只能大於0的整數',
    noLessZero: '不能小於0',
    minTimeNoLessZero: '最小參考時效不能小於0',
    noLessOrEqualZero: '不能小於等於0',
    maxTimeNoLessOrEqualZero: '最大參考時效不能小於等於0',
    lengthNoLessOrEqualZero: '長度不能小於等於0',
    widthNoLessOrEqualZero: '寬度不能小於等於0',
    heightNoLessOrEqualZero: '高度不能小於等於0',
    startWeightNoLessZero: '適用重量起始值不能小於0',
    endWeightNoLessOrEqualZero: '適用重量截止值不能小於等於0',
    trackUrlError: '查詢網址格式不正確',
    noCountrys: '請選擇國家',
    noCitys: '請選擇攬收城市',
    noPackageWeight: '包裹重量不能為空',
    noCompanyName: '公司名稱不能為空',
    noCompanyAddress: '公司地址不能為空',
    noEmail: '郵箱不能為空',
    emailError: '郵箱格式不正確',
    noLinkMan: '聯繫人不能為空',
    noCellphone: '手機號碼不能為空',
    phoneError: '手機號碼格式不正確',
    noStartMoreEnd: '適用重量起始值不能大於等於適用重量截止值',
    noStartTimeMoreEndTime: '參考時效起始值不能大於等於參考時效截止值',
    trackingNumberError: '輸入的跟踪號碼不是數字或者字母',
    noEnterTrackingNumber: '當前沒有輸入跟踪號碼',
    trackingNotRepeat: '跟踪號碼不能重複',
    noHasTrackingNumber: '是否有跟蹤號必填',
    nobusinessLicense: '必須上傳營業執照',
    nocarrierCode: '物流商代碼必填',
    noremark: '備註必填',
    noAccount: '賬號不能爲空',
    noPassword: '密碼不能爲空',
    noBindType: '绑定类型不能为空'
  },
  error: {
    importError: '導入失敗，請填寫必填項',
    repeatImportCountry: '重複導入通達國家',
    importSameCountry: '不能重複添加相同的國家，請重新選擇導入',
    addWeightInterval: '請添加重量區間',
    startWeightNoEmpty: '起始重量不能為空',
    endWeightNoEmpty: '截止重量不能為空',
    endWeightNoZero: '截止重量不能為0',
    endNoLessOrEqualStart: '截止重量不能小於等於起始重量',
    startWeightOnlyInteger: '起始重量只能是正整數',
    endWeightOnlyInteger: '截止重量只能是正整數',
    pricesOnlyFiveDecimals: '價格最多只能保留五位小數',
    firstWeightPriceOnlyFiveDecimals: '首重運費最多只能保留五位小數',
    unitWeightPriceOnlyFiveDecimals: '續重單價最多只能保留五位小數',
    registrationFeeOnlyFiveDecimals: '掛號費最多只能保留五位小數',
    operatingFeeOnlyFiveDecimals: '操作費最多只能保留五位小數',
    additionalFeeOnlyFiveDecimals: '附加費最多只能保留五位小數',
    endMoreStartWeight: '上一個分區的截止重量不能大於等於下一個分區的起始重量',
    countryAlreadyExist: '當前國家在當前計費模型中已經存在了，不能重複選擇',
    importTableError: '導入失敗，請檢查導入的表格內容是否符合要求',
    shippingError: '渠道名稱或渠道代碼已存在',
    saveError: '保存失敗，請檢查你填寫的值是否符合要求',
    fileFormatError: '文件格式不正確',
    noImportFiles: '請選擇你要導入的文件',
    delPricingColumnsError: '至少保留一個重量區間',
    nonCountry: '請選擇通達國家，且不可重複',
    selectModalFile: '請選擇需要導入的模板',
    disableInsert: '有未填寫的分區',
    decimalError: '不能為空，且最多只能保留五位小數',
    priceError: '價格不能為空，且不能為零',
    firstWeightError: '首重不能為空，且不能為零',
    firstWeightPriceError: '首重運費不能為空，且不能為零',
    unitWeightError: '續重不能為空，且不能為零',
    unitWeightPriceError: '續重價格不能為空，且不能為零',
    weightRegionError: '重量區間不能為空的正整數',
    delCachePricingData: '至少保留一條數據',
    templateDataError: '上傳失敗，excel中模板數據不能為空',
    templateDataError14: '普通計費模板表格參數不匹配或不完整',
    templateDataError15: '通達國家不能為空',
    templateDataError16: '運費不能為空',
    templateDataError17: '運費格式錯誤',
    templateDataError18: '掛號費格式錯誤',
    templateDataError19: '操作費格式錯誤',
    templateDataError20: '附加費格式錯誤',
    templateDataError21: '首續重計費表格參數不匹配或不完整',
    templateDataError22: '首重不能為空',
    templateDataError23: '首重格式錯誤',
    templateDataError24: '首重運費不能為空',
    templateDataError25: '首重運費格式錯誤',
    templateDataError26: '續重單位重量不能為空',
    templateDataError27: '續重單位重量格式錯誤',
    templateDataError28: '續重單價不能為空',
    templateDataError29: '續重單價格式錯誤',
    templateDataError30: '運費價格必須大於0',
    templateDataError31: '通達國家沒在系統找到',
    templateDataError32: '首重重量必須大於0',
    templateDataError33: '首重運費必須大於0',
    templateDataError34: '續重重量必須大於0',
    templateDataError35: '續重運費必須大於0',
    templateDataError36: '區間續重重量或運費必須大於0',
    templateDataError37: '區間續重重量或運費格式錯誤',
    templateDataError38: '分段計費表格參數不匹配或不完整',
    templateDataError41: '物流對賬文件內容不匹配',
    templateDataError42: '物流商重量格式錯誤',
    templateDataError43: '物流商費用格式錯誤',
    currentNoData: '當前沒有操作表格數據',
    importWayBillNumExists: '導入的運單號已存在',
    shipDateNoEmpty: '發貨日期不能為空',
    curTableNotData: '當前表格數據為空，不能導入Excel的數據',
    errorTip10029: '國家信息不能為空',
    errorTip20044: '包裹重量不能為空',
    errorTip20045: '包裹體積不能為空',
    errorTip10006: '刪除失敗',
    errorTip90002: '系統繁忙，請稍候再試',
    errorTip90003: '系統內部異常，請聯繫管理員',
    errorTip90004: '數據庫異常',
    errorTip10010: '參數錯誤',
    errorTip10011: '參數為空',
    errorTip10012: '參數對象為空',
    errorTip10014: 'CLIENT ID不合法',
    errorTip10015: 'SECRET不合法',
    errorTip10016: '對像已存在',
    errorTip10017: 'RESTFUL調用失敗',
    errorTip10018: '對象為空',
    errorTip10019: '訪問ES異常',
    errorTip10020: '查詢跟踪信息異常',
    errorTip10021: '物流商不存在',
    errorTip10022: 'Excel文件格式錯誤',
    errorTip10023: '沒有找到物流商',
    errorTip10024: '沒有找到系統國家信息',
    errorTip10025: 'Excel文件導出異常',
    errorTip10026: '未找到結果信息',
    errorTip10027: '商戶ID不能為空',
    errorTip10028: '渠道ID不能為空',
    errorTip20050: '跟踪號參數文件為空',
    errorTip20051: '修改渠道狀態參數為空',
    errorTip20052: '修改渠道id參數為空',
    errorTip20053: '計費方式參數為空',
    errorTip20054: '計費模型文件參數為空',
    errorTip20055: 'EXCEL文件格式錯誤，請在附加費列填值，沒有就填寫0',
    errorTip20056: '文件參數為空',
    errorTip20057: '保存統計報表參數列表為空',
    errorTip20073: '是否有跟蹤號值爲空',
    errorTip20074: '倉庫代碼不能爲空',
    errorTip20075: '倉庫名稱不能爲空',
    errorTip20076: '倉庫名稱或代碼已存在',
    errorTip20077: '倉庫ID不能爲空',
    errorTip20078: '倉庫狀態不能爲空',
    errorTip20079: '接口代碼不能爲空',
    selectWarehouse: '請先選擇倉庫'
  }
};



// WEBPACK FOOTER //
// ./src/components/locale/lang/zh-TW.js